import { effect, ElementRef, signal, Signal } from '@angular/core';

let context: CanvasRenderingContext2D | undefined;

function getContext(): CanvasRenderingContext2D {
  if (context) return context;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not create canvas context');

  context = ctx;
  return context;
}

export function measureTextWidth(text: string, font = '16px Arial') {
  const context = getContext();
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

let measurerEl: HTMLSpanElement | undefined;

function getMeasurerEl(): HTMLSpanElement {
  if (measurerEl) return measurerEl;

  const el = document.createElement('span');
  el.style.position = 'absolute';
  el.style.visibility = 'hidden';
  el.style.whiteSpace = 'nowrap';
  el.style.top = '-9999px';
  el.style.left = '-9999px';
  document.body.appendChild(el);

  measurerEl = el;
  return measurerEl;
}

export function measureRenderedTextWidth(text: string, className: string): number {
  const el = getMeasurerEl();
  el.className = className;
  el.textContent = text;
  return el.getBoundingClientRect().width;
}

export function elementWidthSignal(
  target: Signal<ElementRef<Element>> | Signal<ElementRef<Element> | undefined>,
): Signal<DOMRectReadOnly | undefined> {
  const size = signal<DOMRectReadOnly | undefined>(undefined);

  effect((onCleanup) => {
    const elRef = target();
    if (!(elRef instanceof ElementRef) || !(elRef.nativeElement instanceof Element)) return;
    const el = elRef.nativeElement;

    const observer = new ResizeObserver(([entry]) => {
      size.set(entry.contentRect);
    });
    observer.observe(el);

    onCleanup(() => observer.disconnect());
  });

  return size.asReadonly();
}
